import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { isEqual } from "lodash";
import { closeCustomModal, openCustomModal } from "components/custom/modals";
import UsersHasPermissionsTable from "components/menu/file-manager/ume/users-has-permissions-table";
import {
    umeGetFolderPermissions
} from "api/menu/file-manager/actions";

const FolderPermissionsModal = React.lazy(() =>
    import("components/menu/file-manager/ume/folder-permissions-modal"));

class UsersHasPermissions extends Component {
    constructor(props) {
        super(props);

        this.handlePermissionModal = this.handlePermissionModal.bind(this);

        if (this.props.selectedFolder) {
            this.props.umeGetFolderPermissions(this.props.selectedFolder);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!isEqual(nextProps.selectedFolder, this.props.selectedFolder)
            && nextProps.selectedFolder) {
            this.props.umeGetFolderPermissions(nextProps.selectedFolder);
        }
    }

    handlePermissionModal = () => {
        const {
            selectedFolder,
        } = this.props;

        const modalObj = {
            header: "Folder Permissions",
            modalSettings: {
                size: "sm",
            },
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <FolderPermissionsModal
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                        folderName={selectedFolder}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    render () {
        const { selectedFolder } = this.props;
        return (
            <div className="position-relative file-manager-menu h-100">
                <div className="border-bottom p-2 file-manager-title bg-info">
                    <h4 className="p-0 m-0 text-light">Permissions</h4>
                </div>
                <div>
                    <button
                        className="btn btn-sm btn-warning"
                        disabled={!selectedFolder}
                        onClick={this.handlePermissionModal}
                    >
                        Edit Folder Permission
                    </button>
                </div>
                <UsersHasPermissionsTable
                    isEditable={false}
                    onRemove={false}
                    style={{ height: 220 }}
                />
                <div className="px-2">
                    <div className="custom-control custom-checkbox mb-2">
                        <input
                            id="email-on-new-file"
                            type="checkbox"
                            checked={false}
                            className="custom-control-input"
                            onChange={(ev) => {
                                // console.log("ev", ev.target.value);
                            }}
                        />
                        <label
                            className="custom-control-label"
                            htmlFor="email-on-new-file"
                        >
                            Email on a new file upload
                        </label>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    selectedFolder: state.fileManager.selectedFolder,
});

const mapStateToDispatch = dispatch => ({
    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

    umeGetFolderPermissions: bindActionCreators(umeGetFolderPermissions, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(UsersHasPermissions);
